module.exports = __webpack_public_path__ + "static/media/IMG_1517.3d044616.jpg";